import React from 'react';
import {
  Box,
  Fab,
  Tooltip,
  Zoom,
} from "@mui/material";
import {
  WhatsApp as WhatsAppIcon,
} from "@mui/icons-material";
import { motion, useScroll, useSpring } from "framer-motion";
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Footer from './Footer';
import LeadPopup from './LeadPopup';
import CartNotificationToast from './CartNotificationToast';
import BottomNavMobile from './BottomNavMobile';

const Layout = ({ children }) => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const whatsappMessage = encodeURIComponent("Hi! I'm interested in AR Infotech software licenses. Can you help me with my purchase?");
  const whatsappNumber = "919113299131";

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative' }}>
      {/* Scroll Progress Bar */}
      {/* <motion.div
        style={{
          scaleX,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          backgroundColor: '#00D2C4',
          transformOrigin: '0%',
          zIndex: 2000
        }}
      /> */}

      <AnnouncementBar />
      <Header />
      <Box component="main" sx={{ flexGrow: 1, pb: { xs: '68px', sm: 0 } }}>
        {children}
      </Box>
      <Footer />
      <LeadPopup />
      <CartNotificationToast />
      <BottomNavMobile />

      {/* Floating WhatsApp Button */}
      <Box
        component={motion.div}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2, type: 'spring' }}
        sx={{
          position: 'fixed',
          bottom: { xs: 76, sm: 30 },
          right: { xs: 16, sm: 30 },
          zIndex: 1500
        }}
      >
        <Tooltip title="Talk to our License Expert" arrow placement="left" TransitionComponent={Zoom}>
          <Fab
            component="a"
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            size="large"
            sx={{
              bgcolor: '#25D366', color: 'white',
              '&:hover': { bgcolor: '#128C7E', transform: 'scale(1.1)' },
              boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)'
            }}
          >
            <WhatsAppIcon />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Layout;
